// API Documentation page i18n translations
// Keys prefixed with 'doc_' to avoid conflicts with existing translations

export const apiDocTranslations = {
  'zh-CN': {
    // Tab labels
    doc_tabDoc: 'API 文档',
    doc_tabOverview: 'API 总览',
    doc_tabDetail: 'API 详情',
    doc_tabGuide: '接入指南',
    doc_tabMatrix: '渠道能力',
    doc_tabAdmin: '配置管理',

    // Matrix stats
    doc_statChannels: '渠道',
    doc_statRegions: '区域',
    doc_statCurrencies: '币种',
    doc_statConfigurations: '配置项',
    doc_matrixSubtitle: '所有支付渠道的区域、币种和能力概览',
    doc_filterLabel: '筛选',

    // Filter bar
    doc_selectApi: '选择接口',
    doc_selectChannel: '选择渠道',
    doc_channelCount: (n) => `${n} 个渠道`,

    // API overview
    doc_totalApis: (n) => `共 ${n} 个接口，按业务模块分组展示，点击任意行查看详情`,
    doc_apiCount: (n) => `${n} 个接口`,
    doc_colMethod: '方法',
    doc_colPath: '接口路径',
    doc_colName: '名称',
    doc_colDesc: '说明',

    // Common response
    doc_commonResponse: '通用响应结构',
    doc_commonResponseDesc: '所有接口响应均遵循统一包装格式，业务数据在',
    doc_commonResponseDesc2: '字段中返回。',

    // Error codes
    doc_errorCodeLookup: '错误码速查',
    doc_colCategory: '分类',
    doc_colAction: '处理建议',

    // Detail columns
    doc_colField: '字段名',
    doc_colLabel: '标签',
    doc_colType: '类型',
    doc_colRequired: '必填',
    doc_colDescDetail: '说明',
    doc_yes: '是',
    doc_no: '否',
    doc_example: '示例',

    // Request/Response sections
    doc_requestParams: '请求参数',
    doc_extParamFields: 'extParam 差异字段',
    doc_noExtParam: '该渠道无额外 extParam 字段',
    doc_exampleRequest: '示例请求',
    doc_responseParams: '响应参数',
    doc_exampleResponse: '示例响应',
    doc_noConfig: '该渠道暂无配置',

    // Copy button
    doc_copy: '复制',
    doc_copied: '已复制',

    // Channel capability matrix
    doc_region: '区域',
    doc_channelType: '渠道类型',
    doc_channelCount2: (n) => `${n} 个渠道`,
    doc_dataSource: '数据来源',
    doc_colChannel: '渠道',
    doc_colType2: '类型',
    doc_colRegion: '区域',
    doc_colEntity: '主体',
    doc_colKeyFunction: '关键职能',
    doc_colCountry: '国家',
    doc_colCurrency: '币种',
    doc_colPaymentMethod: '支付方式',
    doc_colUserType: '用户类型',
    doc_userAll: '全部',
    doc_userBiz: '企业',
    doc_userIndividual: '个人',
    doc_colOpenAccount: '开户',
    doc_colDeposit: '充值',
    doc_colWithdraw: '提现',
    doc_colRefund: '退款',
    doc_colPartialRefund: '部分退款',
    doc_colSameNameVa: '同名VA',
    doc_capabilities: '能力支持',

    // Admin panel
    doc_addConfig: '新增配置',
    doc_refreshCache: '刷新缓存',
    doc_totalConfigs: (n) => `共 ${n} 条配置`,
    doc_totalPagination: (n) => `共 ${n} 条`,
    doc_editMeta: '编辑元数据',
    doc_addMeta: '新增元数据',
    doc_channelCodeLabel: '渠道代码',
    doc_apiNameLabel: 'API 名称',
    doc_descLabel: '描述',
    doc_fieldConfig: '字段配置 (JSON)',
    doc_fieldConfigExtra: 'JSON 数组格式，每个元素包含 name, label, type, required, group, options, placeholder, tip 等字段',
    doc_exampleRequestJson: '示例请求 (JSON)',
    doc_adminEdit: '编辑',
    doc_adminCopy: '复制',
    doc_adminDelete: '删除',
    doc_confirmDelete: '确认删除？',
    doc_adminChannel: '渠道',
    doc_adminStatus: '状态',
    doc_adminVersion: '版本',
    doc_adminCreator: '创建人',
    doc_adminAction: '操作',
    doc_loadFailed: '加载失败',
    doc_updateSuccess: '更新成功',
    doc_createSuccess: '创建成功',
    doc_jsonError: 'JSON 格式错误，请检查',
    doc_saveFailed: '保存失败',
    doc_deleteSuccess: '删除成功',
    doc_deleteFailed: '删除失败',
    doc_cacheRefreshed: '缓存刷新成功',
    doc_refreshFailed: '刷新失败',

    // SCENE_OPTIONS group labels
    doc_grpAccount: '账户',
    doc_grpBankAccount: '银行账户',
    doc_grpDeposit: '充值',
    doc_grpWithdraw: '提现',
    doc_grpRefund: '退款',
    doc_grpUser: '用户',
    doc_grpFile: '文件',
    doc_grpGeneral: '通用查询',

    // API labels (for SCENE_OPTIONS & API_CODE_LABELS)
    doc_apiAccountCreate: '开户',
    doc_apiAccountClose: '关户',
    doc_apiAccountQuery: '开户查询',
    doc_apiCardBind: '绑定银行账户',
    doc_apiCardQuery: '绑定银行账户查询',
    doc_apiCardUnbind: '解绑',
    doc_apiDepositCreate: '充值',
    doc_apiDepositQuery: '充值查询',
    doc_apiRefundCreate: '退款',
    doc_apiRefundQuery: '退款查询',
    doc_apiWithdrawCreate: '提现',
    doc_apiWithdrawQuery: '提现查询',
    doc_apiChannelConfig: '渠道配置查询',
    doc_apiOrderPage: '订单列表',
    doc_apiBankList: '银行列表',
    doc_apiFileUpload: '文件上传',
    doc_apiFileStatusQuery: '文件状态查询',
    doc_apiUserCreate: '创建用户',
    doc_apiUserQuery: '查询用户',
    doc_apiBalanceQuery: '余额查询',
    doc_apiRateQuery: '汇率查询',
    doc_apiPayoutRequirements: '走廊字段要求',

    // API descriptions
    doc_descAccountCreate: '为用户创建渠道账户（VA 或渠道账户）',
    doc_descAccountClose: '为用户关闭渠道账户',
    doc_descAccountQuery: '查询用户渠道账户信息',
    doc_descCardBind: '绑定银行账户',
    doc_descCardQuery: '查询绑定的银行账户信息',
    doc_descCardUnbind: '解绑银行账户',
    doc_descDepositCreate: '创建充值订单',
    doc_descDepositQuery: '查询充值订单结果',
    doc_descRefundCreate: '发起全额退款（仅部分渠道支持）',
    doc_descRefundQuery: '查询退款订单',
    doc_descWithdrawCreate: '创建提现订单',
    doc_descWithdrawQuery: '查询提现订单结果',
    doc_descChannelConfig: '查询渠道基础配置信息',
    doc_descOrderPage: '分页查询订单列表',
    doc_descBankList: '查询有效银行列表',
    doc_descFileUpload: '上传业务文件（KYC/EDD等），Content-Type: multipart/form-data',
    doc_descFileStatusQuery: '批量查询文件上传状态',
    doc_descUserCreate: '创建渠道用户（支持 PYVIO / TAZAPAY）',
    doc_descUserQuery: '查询渠道用户详细信息',
    doc_descBalanceQuery: '查询渠道可用余额',
    doc_descRateQuery: '查询渠道汇率',
    doc_descPayoutRequirements: '查询指定走廊（国家+币种）的绑卡/提现字段要求，返回必填字段、推荐字段和转账限额',

    // Corridor Requirements Query panel
    doc_corridorTitle: '走廊字段要求查询',
    doc_corridorDesc: '选择国家和币种，查看该走廊绑卡所需的字段。推荐字段建议都传',
    doc_corridorCountry: '国家',
    doc_corridorCurrency: '币种',
    doc_corridorSelectCountry: '选择国家',
    doc_corridorSelectCurrency: '选择币种',
    doc_corridorSelectCountryFirst: '请先选择国家',
    doc_corridorRequired: '必填',
    doc_corridorRecommended: '推荐',
    doc_corridorMainFields: '主字段',
    doc_corridorExtFields: '扩展参数',
    doc_corridorNetworks: '清算网络',
    doc_corridorLimit: '限额',
    doc_corridorLoading: '查询中...',
    doc_corridorFieldsHint: '以下字段根据走廊动态返回，标记为必填的字段在绑卡时必须传入。',
    doc_corridorPayoutType: '付款类型',

    // Error categories
    doc_catSuccess: '成功',
    doc_catClient: '参数错误',
    doc_catSignature: '签名错误',
    doc_catVerification: '验证错误',
    doc_catRisk: '风控',
    doc_catSystem: '系统/渠道',

    // Error code descriptions
    doc_err000000: '成功',
    doc_err000000Action: '无需处理',
    doc_err400001: '参数无效: {param}',
    doc_err400001Action: '检查请求参数格式和取值范围',
    doc_err400002: '缺少必填参数: {param}',
    doc_err400002Action: '补充缺失的必填参数',
    doc_err400003: '请求被限流',
    doc_err400003Action: '降低请求频率，稍后重试',
    doc_err400004: '资源不存在: {resourceId}',
    doc_err400004Action: '确认资源 ID 是否正确',
    doc_err400005: '不支持的操作: {operation}',
    doc_err400005Action: '检查接口是否支持该操作',
    doc_err400006: '重复请求',
    doc_err400006Action: '更换 requestId 或 externalOrderId',
    doc_err400201: '签名验证失败: {reason}',
    doc_err400201Action: '检查签名算法(SHA384withECDSA)、密钥和签名串拼接',
    doc_err400301: '姓名验证失败: {reason}',
    doc_err400301Action: '确认姓名信息是否正确',
    doc_err400401: '风控拒绝: {reason}',
    doc_err400401Action: '查看 reason 详情，调整业务参数后重试',
    doc_err400402: '风控处理失败: {reason}',
    doc_err400402Action: '联系技术支持排查风控规则',
    doc_err500001: '系统内部错误',
    doc_err500001Action: '联系技术支持',
    doc_err500002: '渠道不可用: {channel}',
    doc_err500002Action: '确认渠道状态或联系管理员',
    doc_err500003: '服务暂时不可用',
    doc_err500003Action: '稍后重试',
    doc_err500004: '渠道超时: {channel}',
    doc_err500004Action: '稍后重试或查询订单状态',
    doc_err500005: '渠道配置错误: {channel}',
    doc_err500005Action: '联系管理员检查渠道配置',
    doc_err500006: '渠道响应无效: {channel}',
    doc_err500006Action: '联系技术支持排查渠道响应',
    doc_err500007: '渠道限流: {channel}',
    doc_err500007Action: '降低请求频率，稍后重试',
    doc_err500008: '渠道响应失败: {channel}',
    doc_err500008Action: '查看 errorMsg 获取渠道侧错误详情',
    doc_err500009: '与渠道通信网络错误: {channel}',
    doc_err500009Action: '稍后重试',
    doc_err500010: '渠道 JSON 响应解析失败: {channel}',
    doc_err500010Action: '联系技术支持排查渠道响应格式',

    // Guide tab
    doc_guideIntro: '本指南基于 Fiat Payment Open API v1 规范，帮助业务方完成从环境准备到生产上线的全流程接入。',
    doc_guideS1Title: '环境与网络',
    doc_guideS1Env: '环境',
    doc_guideS1Endpoint: 'API Endpoint',
    doc_guideS1CnLine: '中国大陆专线',
    doc_guideS1ContentType: 'Content-Type',
    doc_guideS1Timestamp: '时间戳: Unix Epoch Milliseconds (UTC)',
    doc_guideS1Whitelist: '业务方需提供出口 IP 用于白名单配置；Webhook 来源 IP: 3.78.97.230 / 3.123.207.216',
    doc_guideS2Title: 'API 认证 Headers',
    doc_guideS2Desc: '所有请求必须携带以下 Header：',
    doc_guideS2Required: '必填',
    doc_guideS2AppIdDesc: '分配的应用标识（API Key）',
    doc_guideS2TimestampDesc: 'Unix Epoch 毫秒时间戳 (UTC)',
    doc_guideS2SignatureDesc: 'Base64 编码的 ECC-SHA384withECDSA 签名',
    doc_guideS2Warning: 'timestamp 允许偏移 ±5 分钟，超出将返回签名时间错误。appId 必须安全存储，禁止泄露。',
    doc_guideS3Title: '签名机制 (ECC-SHA384withECDSA)',
    doc_guideS3Desc: 'Fiat Channel 采用',
    doc_guideS3ECC: 'ECC 椭圆曲线',
    doc_guideS3Desc2: '签名（非 RSA），算法为',
    doc_guideS3Desc3: '。系统使用两套独立密钥体系：',
    doc_guideS3MerchantKey: '商户密钥对',
    doc_guideS3MerchantPriv: '私钥 → 商户持有，签名 API 请求',
    doc_guideS3MerchantPub: '公钥 → 提供给 Fiat Channel 验签',
    doc_guideS3WebhookKey: '平台 Webhook 密钥对',
    doc_guideS3WebhookPriv: '私钥 → Fiat Channel 持有，签名 Webhook',
    doc_guideS3WebhookPub: '公钥 → 提供给商户验签',
    doc_guideS3Plaintext: '签名原文 (Plaintext)',
    doc_guideS3BodyRule: 'bodyJsonString 序列化规则（必须一致）',
    doc_guideS3BodyDesc: '字段按字典序排列，null 值不参与序列化。推荐 Jackson 配置：',
    doc_guideS3KeyGen: '密钥生成命令',
    doc_guideS3KeyNote: 'ECC 仅用于数字签名，不用于接口数据加密。',

    doc_guideS4Title: '金额与币种规范',
    doc_guideS4Desc: '所有金额必须以精确到小数点后',
    doc_guideS4Two: '两位',
    doc_guideS4Desc2: '的十进制字符串表示，适用于所有币种（含 IDR / JPY / KRW）。API 不会自动四舍五入。',
    doc_guideS4Rule: '规则',
    doc_guideS4NoSci: '不允许科学计数法',
    doc_guideS4NoComma: '不允许千分位',
    doc_guideS4UseDot: '使用 . 作为小数点',
    doc_guideS4NoTrail: '不允许尾随空格',
    doc_guideS4NoExtra: '不允许多余小数位',
    doc_guideS4ExceedPrecision: '超出精度 ❌',
    doc_guideS5Title: '统一响应模型',
    doc_guideS5Field: '字段',
    doc_guideS5Type: '类型',
    doc_guideS5Desc: '说明',
    doc_guideS5CodeDesc: 'HTTP 业务状态码',
    doc_guideS5SubCodeDesc: '6 位业务错误码，000000 = 成功',
    doc_guideS5MsgDesc: '英文错误描述',
    doc_guideS5TimeDesc: '请求时间 (epoch ms)',
    doc_guideS5ReqIdDesc: '请求唯一标识',
    doc_guideS5DataDesc: '返回数据',
    doc_guideS6Title: '错误码速查',
    doc_guideS6ErrCode: '错误码',
    doc_guideS6Desc: '说明',
    doc_guideS6Action: '处理建议',
    doc_guideS6Success: '请求成功',
    doc_guideS6SuccessAction: '—',
    doc_guideS6Client: '客户端错误（参数/格式）',
    doc_guideS6ClientAction: '不可重试，检查入参',
    doc_guideS6Sign: '签名相关错误',
    doc_guideS6SignAction: '检查签名实现与时间戳',
    doc_guideS6System: '系统或渠道错误',
    doc_guideS6SystemAction: '可重试',

    doc_guideS7Title: 'Webhook 回调',
    doc_guideS7Desc: '业务方需提供 HTTPS POST 接口接收异步通知。Webhook Header 包含签名信息：',
    doc_guideS7Verify: '验签逻辑：使用 Fiat Channel 提供的 Webhook 公钥验证 body 签名。',
    doc_guideS7Warning: '未通过验签的 Webhook 必须拒绝处理。线下入金渠道需额外提供默认 Callback URL（Sandbox / Production 各一个）。',
    doc_guideS8Title: '接入 Checklist',
    doc_guideS8CheckItem: '检查项',
    doc_guideS8Cat: '分类',
    doc_guideS8CatEnv: '环境',
    doc_guideS8CatAuth: '认证',
    doc_guideS8CatSign: '签名',
    doc_guideS8CatCallback: '回调',
    doc_guideS8CatBiz: '业务',
    doc_guideS8Items: [
      { item: '网络打通（Sandbox + Production）', cat: '环境' },
      { item: 'API Key (appId) 配置', cat: '认证' },
      { item: 'ECC 密钥对生成 & 公钥交换', cat: '签名' },
      { item: '签名原文拼接 & SHA384withECDSA 签名验证通过', cat: '签名' },
      { item: 'bodyJsonString 序列化规则一致（字典序 + NON_NULL）', cat: '签名' },
      { item: 'Webhook 接口开发 & 验签逻辑', cat: '回调' },
      { item: 'Fiat Channel Webhook 公钥保存', cat: '回调' },
      { item: '金额精度校验（2 位小数，无科学计数法）', cat: '业务' },
      { item: 'requestId 幂等性保证', cat: '业务' },
      { item: 'timestamp ±5min 时间窗口校验', cat: '业务' },
      { item: '默认 callbackUrl 提供（线下入金）', cat: '回调' },
    ],
    doc_guideS9Title: '推荐接入流程',
    doc_guideS9Steps: [
      { step: '环境准备', desc: '网络打通、出口 IP 白名单配置' },
      { step: '密钥交换', desc: '生成 ECC 密钥对，交换公钥' },
      { step: 'API Key 分配', desc: '获取 appId，配置 Header' },
      { step: 'Sandbox 开发', desc: '实现签名、接口调用、Webhook 接收' },
      { step: 'Sandbox 联调', desc: '全场景功能验证 & 签名验证' },
      { step: 'Production 配置', desc: '切换 Endpoint、更新密钥与 callbackUrl' },
      { step: '生产上线', desc: '灰度验证 → 全量放开' },
    ],

    doc_guideS10Title: '信息交换清单',
    doc_guideS10FiatProvides: 'Fiat Channel 提供',
    doc_guideS10FiatItems: ['API Endpoint (Sandbox + Prod)', 'appId (API Key)', 'Webhook ECC 公钥', 'Webhook 来源 IP'],
    doc_guideS10BizProvides: '业务方提供',
    doc_guideS10BizItems: ['出口 IP（用于白名单）', 'ECC 公钥（用于请求验签）', 'Webhook 接收 URL', '默认 Callback URL（线下入金）'],

    // Webhook Tab
    doc_tabWebhook: 'Webhook 回调',
    doc_webhookTitle: 'Webhook 异步回调',
    doc_webhookSubtitle: '当交易状态发生变化时，Fiat Payment 平台会通过 Webhook 异步通知商户。',
    doc_webhookSecurity: 'Webhook 安全',
    doc_webhookSecurityDesc1: 'Webhook 消息由 Fiat Payment 平台私钥签名',
    doc_webhookSecurityDesc2: '商户需使用平台公钥进行验签',
    doc_webhookSecurityDesc3: 'Webhook 消息签名但不加密',
    doc_webhookRetry: '重试机制',
    doc_webhookRetryDesc: '最大重试次数：5 次，采用指数退避策略',
    doc_webhookRetryWarning: '请确保 Webhook 接口幂等，避免重复处理。返回 HTTP 200 表示接收成功，否则将触发重试。',
    doc_webhookRequestBody: 'Webhook 请求体',
    doc_webhookFieldMsgId: 'Webhook 消息唯一 ID',
    doc_webhookFieldEventType: '事件类型',
    doc_webhookFieldVersion: '消息版本，固定 1.0.0',
    doc_webhookFieldData: '业务数据（JSON 字符串），结构因 eventType 而异',
    doc_webhookEventTypes: '事件类型说明',
    doc_webhookEventAccount: '开户',
    doc_webhookEventCard: '绑定银行账户',
    doc_webhookEventDeposit: '充值',
    doc_webhookEventWithdraw: '提现',
    doc_webhookEventRefund: '退款',
    doc_webhookEventUser: '用户创建',
    doc_webhookDataStructure: 'data 结构',
    doc_webhookSelectEvent: '选择事件类型查看 data 结构',
    doc_webhookFieldName: '参数名',
    doc_webhookFieldType: '类型',
    doc_webhookFieldRequired: '必须',
    doc_webhookFieldDesc: '描述',
    doc_webhookVerifyTitle: '验签说明',
    doc_webhookVerifyDesc: '使用 Fiat Channel 提供的 Webhook 公钥，对 body 内容进行 SHA384withECDSA 验签。',
    doc_webhookVerifyWarning: '未通过验签的 Webhook 必须拒绝处理。',
    doc_webhookHeaderDesc: 'Webhook 请求 Header 包含签名信息：',
    doc_webhookExample: '示例',
  },

  'en-US': {
    // Tab labels
    doc_tabDoc: 'API Docs',
    doc_tabOverview: 'API Overview',
    doc_tabDetail: 'API Details',
    doc_tabGuide: 'Integration Guide',
    doc_tabMatrix: 'Channel Capability',
    doc_tabAdmin: 'Config Management',

    // Matrix stats
    doc_statChannels: 'Channels',
    doc_statRegions: 'Regions',
    doc_statCurrencies: 'Currencies',
    doc_statConfigurations: 'Configurations',
    doc_matrixSubtitle: 'Overview of all payment channels, supported regions, currencies, and capabilities',
    doc_filterLabel: 'Filters',

    // Filter bar
    doc_selectApi: 'Select API',
    doc_selectChannel: 'Select Channel',
    doc_channelCount: (n) => `${n} channels`,

    // API overview
    doc_totalApis: (n) => `${n} APIs in total, grouped by module. Click any row for details`,
    doc_apiCount: (n) => `${n} APIs`,
    doc_colMethod: 'Method',
    doc_colPath: 'Endpoint',
    doc_colName: 'Name',
    doc_colDesc: 'Description',

    // Common response
    doc_commonResponse: 'Common Response Structure',
    doc_commonResponseDesc: 'All API responses follow a unified wrapper format. Business data is returned in the',
    doc_commonResponseDesc2: 'field.',

    // Error codes
    doc_errorCodeLookup: 'Error Code Reference',
    doc_colCategory: 'Category',
    doc_colAction: 'Suggested Action',

    // Detail columns
    doc_colField: 'Field',
    doc_colLabel: 'Label',
    doc_colType: 'Type',
    doc_colRequired: 'Required',
    doc_colDescDetail: 'Description',
    doc_yes: 'Yes',
    doc_no: 'No',
    doc_example: 'Example',

    // Request/Response sections
    doc_requestParams: 'Request Parameters',
    doc_extParamFields: 'extParam Diff Fields',
    doc_noExtParam: 'No additional extParam fields for this channel',
    doc_exampleRequest: 'Example Request',
    doc_responseParams: 'Response Parameters',
    doc_exampleResponse: 'Example Response',
    doc_noConfig: 'No configuration for this channel',

    // Copy button
    doc_copy: 'Copy',
    doc_copied: 'Copied',

    // Channel capability matrix
    doc_region: 'Region',
    doc_channelType: 'Channel Type',
    doc_channelCount2: (n) => `${n} channels`,
    doc_dataSource: 'Data source',
    doc_colChannel: 'Channel',
    doc_colType2: 'Type',
    doc_colRegion: 'Region',
    doc_colEntity: 'Entity',
    doc_colKeyFunction: 'Key Function',
    doc_colCountry: 'Country',
    doc_colCurrency: 'Currency',
    doc_colPaymentMethod: 'Payment Method',
    doc_colUserType: 'User Type',
    doc_userAll: 'All',
    doc_userBiz: 'Business',
    doc_userIndividual: 'Individual',
    doc_colOpenAccount: 'Account',
    doc_colDeposit: 'Deposit',
    doc_colWithdraw: 'Withdraw',
    doc_colRefund: 'Refund',
    doc_colPartialRefund: 'Partial Refund',
    doc_colSameNameVa: 'Same Name VA',
    doc_capabilities: 'Capabilities',

    // Admin panel
    doc_addConfig: 'Add Config',
    doc_refreshCache: 'Refresh Cache',
    doc_totalConfigs: (n) => `${n} configs total`,
    doc_totalPagination: (n) => `Total ${n}`,
    doc_editMeta: 'Edit Metadata',
    doc_addMeta: 'Add Metadata',
    doc_channelCodeLabel: 'Channel Code',
    doc_apiNameLabel: 'API Name',
    doc_descLabel: 'Description',
    doc_fieldConfig: 'Field Config (JSON)',
    doc_fieldConfigExtra: 'JSON array format, each element contains name, label, type, required, group, options, placeholder, tip fields',
    doc_exampleRequestJson: 'Example Request (JSON)',
    doc_adminEdit: 'Edit',
    doc_adminCopy: 'Copy',
    doc_adminDelete: 'Delete',
    doc_confirmDelete: 'Confirm delete?',
    doc_adminChannel: 'Channel',
    doc_adminStatus: 'Status',
    doc_adminVersion: 'Version',
    doc_adminCreator: 'Creator',
    doc_adminAction: 'Action',
    doc_loadFailed: 'Load failed',
    doc_updateSuccess: 'Updated successfully',
    doc_createSuccess: 'Created successfully',
    doc_jsonError: 'Invalid JSON format, please check',
    doc_saveFailed: 'Save failed',
    doc_deleteSuccess: 'Deleted successfully',
    doc_deleteFailed: 'Delete failed',
    doc_cacheRefreshed: 'Cache refreshed successfully',
    doc_refreshFailed: 'Refresh failed',

    // SCENE_OPTIONS group labels
    doc_grpAccount: 'Account',
    doc_grpBankAccount: 'Bank Account',
    doc_grpDeposit: 'Deposit',
    doc_grpWithdraw: 'Withdraw',
    doc_grpRefund: 'Refund',
    doc_grpUser: 'User',
    doc_grpFile: 'File',
    doc_grpGeneral: 'General Query',

    // API labels
    doc_apiAccountCreate: 'Account Create',
    doc_apiAccountClose: 'Account Close',
    doc_apiAccountQuery: 'Account Query',
    doc_apiCardBind: 'Bank Account Bind',
    doc_apiCardQuery: 'Bank Account Query',
    doc_apiCardUnbind: 'Unbind',
    doc_apiDepositCreate: 'Deposit',
    doc_apiDepositQuery: 'Deposit Query',
    doc_apiRefundCreate: 'Refund',
    doc_apiRefundQuery: 'Refund Query',
    doc_apiWithdrawCreate: 'Withdraw',
    doc_apiWithdrawQuery: 'Withdraw Query',
    doc_apiChannelConfig: 'Channel Config Query',
    doc_apiOrderPage: 'Order List',
    doc_apiBankList: 'Bank List',
    doc_apiFileUpload: 'File Upload',
    doc_apiFileStatusQuery: 'File Status Query',
    doc_apiUserCreate: 'Create User',
    doc_apiUserQuery: 'Query User',
    doc_apiBalanceQuery: 'Balance Query',
    doc_apiRateQuery: 'Rate Query',
    doc_apiPayoutRequirements: 'Payout Requirements',

    // API descriptions
    doc_descAccountCreate: 'Create channel account for user (VA or channel account)',
    doc_descAccountClose: 'Close channel account for user',
    doc_descAccountQuery: 'Query user channel account info',
    doc_descCardBind: 'Bind bank account',
    doc_descCardQuery: 'Query bound bank account info',
    doc_descCardUnbind: 'Unbind bank account',
    doc_descDepositCreate: 'Create deposit order',
    doc_descDepositQuery: 'Query deposit order result',
    doc_descRefundCreate: 'Initiate full refund (supported by some channels)',
    doc_descRefundQuery: 'Query refund order',
    doc_descWithdrawCreate: 'Create withdrawal order',
    doc_descWithdrawQuery: 'Query withdrawal order result',
    doc_descChannelConfig: 'Query channel basic configuration',
    doc_descOrderPage: 'Paginated order list query',
    doc_descBankList: 'Query active bank list',
    doc_descFileUpload: 'Upload business files (KYC/EDD etc.), Content-Type: multipart/form-data',
    doc_descFileStatusQuery: 'Batch query file upload status',
    doc_descUserCreate: 'Create channel user (supports PYVIO / TAZAPAY)',
    doc_descUserQuery: 'Query channel user details',
    doc_descBalanceQuery: 'Query channel available balance',
    doc_descRateQuery: 'Query channel exchange rate',
    doc_descPayoutRequirements: 'Query required fields, recommended fields and transfer limits for a given corridor (country + currency)',

    // Corridor Requirements Query panel
    doc_corridorTitle: 'Corridor Requirements',
    doc_corridorDesc: 'Select country and currency to check required fields for this corridor.',
    doc_corridorCountry: 'Country',
    doc_corridorCurrency: 'Currency',
    doc_corridorSelectCountry: 'Select Country',
    doc_corridorSelectCurrency: 'Select Currency',
    doc_corridorSelectCountryFirst: 'Select country first',
    doc_corridorRequired: 'Required',
    doc_corridorRecommended: 'Recommended',
    doc_corridorMainFields: 'Main Fields',
    doc_corridorExtFields: 'extParam Fields',
    doc_corridorNetworks: 'Networks',
    doc_corridorLimit: 'Limit',
    doc_corridorLoading: 'Loading...',
    doc_corridorFieldsHint: 'Fields below are dynamically determined by corridor. Required fields must be provided when binding.',
    doc_corridorPayoutType: 'Payout Type',

    // Error categories
    doc_catSuccess: 'Success',
    doc_catClient: 'Parameter',
    doc_catSignature: 'Signature',
    doc_catVerification: 'Verification',
    doc_catRisk: 'Risk Control',
    doc_catSystem: 'System/Channel',

    // Error code descriptions
    doc_err000000: 'Success',
    doc_err000000Action: 'No action needed',
    doc_err400001: 'Invalid parameter: {param}',
    doc_err400001Action: 'Check request parameter format and value range',
    doc_err400002: 'Missing required parameter: {param}',
    doc_err400002Action: 'Provide the missing required parameter',
    doc_err400003: 'Request is rate limited',
    doc_err400003Action: 'Reduce request frequency, retry later',
    doc_err400004: 'Resource not found: {resourceId}',
    doc_err400004Action: 'Verify the resource ID is correct',
    doc_err400005: 'Unsupported operation: {operation}',
    doc_err400005Action: 'Check if the API supports this operation',
    doc_err400006: 'Duplicate request',
    doc_err400006Action: 'Use a different requestId or externalOrderId',
    doc_err400201: 'Signature verification failed: {reason}',
    doc_err400201Action: 'Check signing algorithm (SHA384withECDSA), keys and sign string',
    doc_err400301: 'Name verification failed: {reason}',
    doc_err400301Action: 'Verify the name information is correct',
    doc_err400401: 'Risk control rejected: {reason}',
    doc_err400401Action: 'Check reason details, adjust parameters and retry',
    doc_err400402: 'Risk control failed: {reason}',
    doc_err400402Action: 'Contact technical support to investigate risk rules',
    doc_err500001: 'Internal server error',
    doc_err500001Action: 'Contact technical support',
    doc_err500002: 'Channel unavailable: {channel}',
    doc_err500002Action: 'Confirm channel status or contact admin',
    doc_err500003: 'Service temporarily unavailable',
    doc_err500003Action: 'Retry later',
    doc_err500004: 'Channel timeout: {channel}',
    doc_err500004Action: 'Retry later or query order status',
    doc_err500005: 'Channel configuration error: {channel}',
    doc_err500005Action: 'Contact admin to check channel configuration',
    doc_err500006: 'Invalid response from channel: {channel}',
    doc_err500006Action: 'Contact technical support to investigate channel response',
    doc_err500007: 'Channel rate limited: {channel}',
    doc_err500007Action: 'Reduce request frequency, retry later',
    doc_err500008: 'Channel response failed: {channel}',
    doc_err500008Action: 'Check errorMsg for channel-side error details',
    doc_err500009: 'Network error with channel: {channel}',
    doc_err500009Action: 'Retry later',
    doc_err500010: 'Failed to parse JSON response from channel: {channel}',
    doc_err500010Action: 'Contact technical support to investigate response format',

    // Guide tab
    doc_guideIntro: 'This guide is based on the Fiat Payment Open API v1 specification, helping integrators complete the full process from environment setup to production launch.',
    doc_guideS1Title: 'Environment & Network',
    doc_guideS1Env: 'Environment',
    doc_guideS1Endpoint: 'API Endpoint',
    doc_guideS1CnLine: 'China Mainland Dedicated Line',
    doc_guideS1ContentType: 'Content-Type',
    doc_guideS1Timestamp: 'Timestamp: Unix Epoch Milliseconds (UTC)',
    doc_guideS1Whitelist: 'Integrators must provide egress IP for whitelist configuration; Webhook source IP: 3.78.97.230 / 3.123.207.216',
    doc_guideS2Title: 'API Authentication Headers',
    doc_guideS2Desc: 'All requests must include the following Headers:',
    doc_guideS2Required: 'Required',
    doc_guideS2AppIdDesc: 'Assigned application identifier (API Key)',
    doc_guideS2TimestampDesc: 'Unix Epoch millisecond timestamp (UTC)',
    doc_guideS2SignatureDesc: 'Base64-encoded ECC-SHA384withECDSA signature',
    doc_guideS2Warning: 'Timestamp allows ±5 minute offset; exceeding this returns a signature time error. appId must be stored securely and never exposed.',
    doc_guideS3Title: 'Signing Mechanism (ECC-SHA384withECDSA)',
    doc_guideS3Desc: 'Fiat Channel uses',
    doc_guideS3ECC: 'ECC Elliptic Curve',
    doc_guideS3Desc2: 'signing (not RSA), algorithm:',
    doc_guideS3Desc3: '. The system uses two independent key pairs:',
    doc_guideS3MerchantKey: 'Merchant Key Pair',
    doc_guideS3MerchantPriv: 'Private key → Held by merchant, signs API requests',
    doc_guideS3MerchantPub: 'Public key → Provided to Fiat Channel for verification',
    doc_guideS3WebhookKey: 'Platform Webhook Key Pair',
    doc_guideS3WebhookPriv: 'Private key → Held by Fiat Channel, signs Webhooks',
    doc_guideS3WebhookPub: 'Public key → Provided to merchant for verification',
    doc_guideS3Plaintext: 'Signature Plaintext',
    doc_guideS3BodyRule: 'bodyJsonString Serialization Rules (must be consistent)',
    doc_guideS3BodyDesc: 'Fields sorted alphabetically, null values excluded. Recommended Jackson config:',
    doc_guideS3KeyGen: 'Key Generation Command',
    doc_guideS3KeyNote: 'ECC is used for digital signatures only, not for data encryption.',

    doc_guideS4Title: 'Amount & Currency Rules',
    doc_guideS4Desc: 'All amounts must be represented as decimal strings with exactly',
    doc_guideS4Two: 'two',
    doc_guideS4Desc2: 'decimal places, applicable to all currencies (including IDR / JPY / KRW). The API does not auto-round.',
    doc_guideS4Rule: 'Rule',
    doc_guideS4NoSci: 'No scientific notation',
    doc_guideS4NoComma: 'No thousands separator',
    doc_guideS4UseDot: 'Use . as decimal point',
    doc_guideS4NoTrail: 'No trailing spaces',
    doc_guideS4NoExtra: 'No extra decimal places',
    doc_guideS4ExceedPrecision: 'Exceeds precision ❌',
    doc_guideS5Title: 'Unified Response Model',
    doc_guideS5Field: 'Field',
    doc_guideS5Type: 'Type',
    doc_guideS5Desc: 'Description',
    doc_guideS5CodeDesc: 'HTTP business status code',
    doc_guideS5SubCodeDesc: '6-digit business error code, 000000 = success',
    doc_guideS5MsgDesc: 'English error description',
    doc_guideS5TimeDesc: 'Request time (epoch ms)',
    doc_guideS5ReqIdDesc: 'Unique request identifier',
    doc_guideS5DataDesc: 'Response data',
    doc_guideS6Title: 'Error Code Reference',
    doc_guideS6ErrCode: 'Error Code',
    doc_guideS6Desc: 'Description',
    doc_guideS6Action: 'Suggested Action',
    doc_guideS6Success: 'Request successful',
    doc_guideS6SuccessAction: '—',
    doc_guideS6Client: 'Client error (params/format)',
    doc_guideS6ClientAction: 'Non-retryable, check input',
    doc_guideS6Sign: 'Signature-related error',
    doc_guideS6SignAction: 'Check signing implementation and timestamp',
    doc_guideS6System: 'System or channel error',
    doc_guideS6SystemAction: 'Retryable',

    doc_guideS7Title: 'Webhook Callbacks',
    doc_guideS7Desc: 'Integrators must provide an HTTPS POST endpoint to receive async notifications. Webhook Headers contain signature info:',
    doc_guideS7Verify: 'Verification: Use the Fiat Channel Webhook public key to verify the body signature.',
    doc_guideS7Warning: 'Webhooks that fail verification must be rejected. Offline deposit channels require a default Callback URL (one each for Sandbox / Production).',
    doc_guideS8Title: 'Integration Checklist',
    doc_guideS8CheckItem: 'Check Item',
    doc_guideS8Cat: 'Category',
    doc_guideS8CatEnv: 'Env',
    doc_guideS8CatAuth: 'Auth',
    doc_guideS8CatSign: 'Sign',
    doc_guideS8CatCallback: 'Callback',
    doc_guideS8CatBiz: 'Business',
    doc_guideS8Items: [
      { item: 'Network connectivity (Sandbox + Production)', cat: 'Env' },
      { item: 'API Key (appId) configuration', cat: 'Auth' },
      { item: 'ECC key pair generation & public key exchange', cat: 'Sign' },
      { item: 'Signature plaintext assembly & SHA384withECDSA verification passed', cat: 'Sign' },
      { item: 'bodyJsonString serialization rules consistent (alphabetical + NON_NULL)', cat: 'Sign' },
      { item: 'Webhook endpoint development & verification logic', cat: 'Callback' },
      { item: 'Fiat Channel Webhook public key saved', cat: 'Callback' },
      { item: 'Amount precision validation (2 decimals, no scientific notation)', cat: 'Business' },
      { item: 'requestId idempotency guarantee', cat: 'Business' },
      { item: 'timestamp ±5min time window validation', cat: 'Business' },
      { item: 'Default callbackUrl provided (offline deposit)', cat: 'Callback' },
    ],
    doc_guideS9Title: 'Recommended Integration Flow',
    doc_guideS9Steps: [
      { step: 'Environment Setup', desc: 'Network connectivity, egress IP whitelist configuration' },
      { step: 'Key Exchange', desc: 'Generate ECC key pair, exchange public keys' },
      { step: 'API Key Assignment', desc: 'Obtain appId, configure Headers' },
      { step: 'Sandbox Development', desc: 'Implement signing, API calls, Webhook reception' },
      { step: 'Sandbox Integration', desc: 'Full scenario functional verification & signature verification' },
      { step: 'Production Configuration', desc: 'Switch Endpoint, update keys and callbackUrl' },
      { step: 'Production Launch', desc: 'Canary verification → full rollout' },
    ],

    doc_guideS10Title: 'Information Exchange Checklist',
    doc_guideS10FiatProvides: 'Fiat Channel Provides',
    doc_guideS10FiatItems: ['API Endpoint (Sandbox + Prod)', 'appId (API Key)', 'Webhook ECC Public Key', 'Webhook Source IP'],
    doc_guideS10BizProvides: 'Integrator Provides',
    doc_guideS10BizItems: ['Egress IP (for whitelist)', 'ECC Public Key (for request verification)', 'Webhook Receiving URL', 'Default Callback URL (offline deposit)'],

    // Webhook Tab
    doc_tabWebhook: 'Webhook',
    doc_webhookTitle: 'Webhook Async Callbacks',
    doc_webhookSubtitle: 'When transaction status changes, Fiat Payment platform will notify merchants asynchronously via Webhook.',
    doc_webhookSecurity: 'Webhook Security',
    doc_webhookSecurityDesc1: 'Webhook messages are signed by Fiat Payment platform private key',
    doc_webhookSecurityDesc2: 'Merchants must verify signatures using the platform public key',
    doc_webhookSecurityDesc3: 'Webhook messages are signed but not encrypted',
    doc_webhookRetry: 'Retry Mechanism',
    doc_webhookRetryDesc: 'Max retries: 5, with exponential backoff strategy',
    doc_webhookRetryWarning: 'Ensure your Webhook endpoint is idempotent to avoid duplicate processing. Return HTTP 200 to acknowledge receipt, otherwise retries will be triggered.',
    doc_webhookRequestBody: 'Webhook Request Body',
    doc_webhookFieldMsgId: 'Webhook message unique ID',
    doc_webhookFieldEventType: 'Event type',
    doc_webhookFieldVersion: 'Message version, fixed 1.0.0',
    doc_webhookFieldData: 'Business data (JSON string), structure varies by eventType',
    doc_webhookEventTypes: 'Event Types',
    doc_webhookEventAccount: 'Account Creation',
    doc_webhookEventCard: 'Bank Account Binding',
    doc_webhookEventDeposit: 'Deposit',
    doc_webhookEventWithdraw: 'Withdraw',
    doc_webhookEventRefund: 'Refund',
    doc_webhookEventUser: 'User Creation',
    doc_webhookDataStructure: 'data Structure',
    doc_webhookSelectEvent: 'Select event type to view data structure',
    doc_webhookFieldName: 'Field',
    doc_webhookFieldType: 'Type',
    doc_webhookFieldRequired: 'Required',
    doc_webhookFieldDesc: 'Description',
    doc_webhookVerifyTitle: 'Signature Verification',
    doc_webhookVerifyDesc: 'Use the Webhook public key provided by Fiat Channel to verify the body content with SHA384withECDSA.',
    doc_webhookVerifyWarning: 'Webhooks that fail verification must be rejected.',
    doc_webhookHeaderDesc: 'Webhook request Headers contain signature info:',
    doc_webhookExample: 'Example',
  },
};

// Field label translations for BASE_PARAMS and RESPONSE_PARAMS
// These map Chinese labels to English equivalents
export const fieldLabelMap = {
  // Base params
  '请求ID': 'Request ID',
  '外部用户ID': 'External User ID',
  '币种': 'Currency',
  '渠道代码': 'Channel Code',
  '支付方式': 'Payment Method',
  '用户类型': 'User Type',
  '扩展参数': 'Extended Params',
  '账户ID': 'Account ID',
  '账户姓名': 'Account Name',
  '银行编码': 'Bank Code',
  '卡号': 'Account Number',
  '银行名字': 'Bank Name',
  '银行国家': 'Bank Country',
  '账户类型': 'Account Type',
  '外部订单号': 'External Order ID',
  '金额': 'Amount',
  '充值方式': 'Deposit Method',
  '回调地址': 'Callback URL',
  '跳转地址': 'Redirect URL',
  '过期时间': 'Expiry Date',
  '提现方式': 'Withdraw Method',
  '关户原因': 'Close Reason',
  '绑卡ID': 'Recipient ID',
  '订单号': 'Order ID',
  '外部退款订单号': 'External Refund Order ID',
  '外部退款单号': 'External Refund Order ID',
  '充值订单号': 'Deposit Order ID',
  '订单类型': 'Order Type',
  '退款描述': 'Refund Description',
  '退款单号': 'Refund Order ID',
  '交易类型': 'Order Type',
  '订单状态': 'Order Status',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '页码': 'Page',
  '每页条数': 'Page Size',
  '国家代码': 'Country Code',
  '业务场景': 'Business Scene',
  '文件类型': 'Document Type',
  '业务ID': 'Business ID',
  '文件': 'File',
  '文件国家': 'Document Country',
  '文件面': 'Document Side',
  '文件ID列表': 'File ID List',
  '操作类型': 'Operation Type',
  '用户ID': 'User ID',
  '渠道账户号': 'Channel Account No.',
  '原始币种': 'Origin Currency',
  '目标币种': 'Target Currency',
  '收款人类型': 'Payee Type',
  // extParam labels from DB metadata
  '名': 'First Name',
  '中间名': 'Middle Name',
  '姓': 'Last Name',
  '全名': 'Full Name',
  '手机号': 'Phone',
  '生日': 'Birthday',
  '生日/注册日期': 'DOB / Registration Date',
  '邮箱': 'Email',
  '证件类型': 'ID Type',
  '证件号': 'ID Number',
  '证件号码': 'ID Number',
  '国籍': 'Nationality',
  '国家': 'Country',
  '居住国/注册国': 'Residence / Registration Country',
  '居住城市/注册城市': 'Residence / Registration City',
  '居住地址/注册地址': 'Residence / Registration Address',
  '城市': 'City',
  '街道': 'Street',
  '门牌号': 'House Number',
  '邮编': 'Postal Code',
  '企业类型': 'Business Type',
  '公司名': 'Company Name',
  '描述': 'Description',
  '银行标识': 'Bank Identifier',
  '银行代码': 'Bank Code',
  '银行Code': 'Bank Code',
  '银行流水': 'Bank Reference',
  '银行地址': 'Bank Address',
  '银行城市': 'Bank City',
  '银行州/省': 'Bank State/Province',
  '虚拟账户名': 'Virtual Account Name',
  '虚拟账户名称': 'Virtual Account Name',
  '绑卡类型': 'Bind Type',
  '收款人姓名': 'Recipient Name',
  '收款人电话': 'Recipient Phone',
  '收款人邮箱': 'Recipient Email',
  '收款人国家': 'Recipient Country',
  '收款人城市': 'Recipient City',
  '收款人地址': 'Recipient Address',
  '收款人地址行1': 'Recipient Address Line 1',
  '收款人邮编': 'Recipient Postal Code',
  '收款人税号': 'Recipient Tax ID',
  '付款用途': 'Payment Purpose',
  '付款原因': 'Payment Reason',
  '费用承担方': 'Charge Type',
  '提现目的': 'Withdraw Purpose',
  '提现备注': 'Withdraw Note',
  '转账描述': 'Transfer Description',
  '转账备注': 'Transfer Note',
  '附加备注': 'Additional Note',
  '目标金额': 'Target Amount',
  '汇率ID': 'Rate ID',
  '计算方向': 'Calculation Direction',
  '用途代码': 'Purpose Code',
  '清算网络': 'Clearing Network',
  '协议类型': 'Protocol Type',
  '路由类型': 'Routing Type',
  'ABA路由号': 'ABA Routing Number',
  '分行编号': 'Branch Code',
  '金融机构标识': 'Financial Institution ID',
  '用户名字': 'User Name',
  '用户姓名': 'User Name',
  '用户邮箱': 'User Email',
  '使用者名称': 'User Name',
  '客户姓名': 'Customer Name',
  '客户手机号': 'Customer Phone',
  '客户邮箱': 'Customer Email',
  '客户地址': 'Customer Address',
  '合作关系证明': 'Relationship Proof',
  '原因详情': 'Reason Detail',
  'PIX类型': 'PIX Type',
  'PIX账号': 'PIX Account',
  'CLABE号/借记卡号/手机号': 'CLABE / Debit Card / Phone',
  'BVN号码': 'BVN Number',
  'NIN号码': 'NIN Number',
  // Response labels
  '开户状态': 'Account Status',
  '子状态': 'Sub Status',
  '跳转链接': 'Redirect URL',
  '错误码': 'Error Code',
  '错误信息': 'Error Message',
  '创建时间': 'Create Time',
  '更新时间': 'Update Time',
  '账户详情': 'Account Detail',
  '绑卡状态': 'Bind Status',
  '银行户名': 'Bank Account Name',
  '状态': 'Status',
  '支付信息': 'Payment Info',
  '退款状态': 'Refund Status',
  '渠道': 'Channel',
  '手续费': 'Fee',
  '完成时间': 'Completed Time',
  '付款人信息': 'Sender Info',
  '收款人信息': 'Receiver Info',
  '支付类型': 'Pay Type',
  '类型': 'Type',
  '支付链接': 'Payment URL',
  '二维码内容': 'QR Code',
  '二维码图片': 'QR Code Image',
  '授权ID': 'Authorization ID',
  '授权Token': 'Authorization Token',
  '前端授权Token': 'App Authorization Token',
  '前端链接方式': 'Connect Type',
  '账户号码': 'Account No.',
  '账户名称': 'Account Name',
  '所属银行名称': 'Bank Name',
  'IBAN账号': 'IBAN',
  'VBAN账号': 'VBAN',
  '充值意图': 'Deposit Purpose',
  '备注': 'Remarks',
  '转账时间': 'Transfer Time',
  '地址': 'Address',
  '业务线订单号': 'External Order ID',
  '充值单状态': 'Deposit Status',
  '充值子状态': 'Deposit Sub Status',
  '提现单状态': 'Withdraw Status',
  '提现子状态': 'Withdraw Sub Status',
  '上游订单号': 'External Order ID',
  '绑定银行账户ID': 'Recipient ID',
  '渠道名称': 'Channel Name',
  '国际银行账户号码': 'IBAN',
  '法币币种': 'Fiat Currency',
  '收款人银行地址': 'Recipient Bank Address',
  '区域': 'Region',
  '渠道结算币种': 'Settlement Currency',
  '是否需要VA同名': 'Require VA Same Name',
  '是否需要开户': 'Need Account Opening',
  '充值订单模式': 'Deposit Order Mode',
  '支持部分退款': 'Support Partial Refund',
  '渠道编号': 'Channel Code',
  '合作伙伴': 'Business Partner',
  '账户号': 'Account ID',
  '银行唯一标识': 'Bank Identifier',
  '国际转账限额': 'International Transfer Limits',
  '用户退款到账金额': 'Refund Arrival Amount',
  '持有人名称': 'Holder Name',
  '二维码': 'Bar Code',
  '发送方账户': 'Sender Account No.',
  '发送方账户名称': 'Sender Account Name',
  'SWIFT/BIC Code': 'SWIFT/BIC Code',
  '发送方地址': 'Sender Address',
  '发送方国家代码': 'Sender Country Code',
  '渠道编码': 'Channel Code',
  '最小转账金额': 'Min Transfer Amount',
  '最大转账金额': 'Max Transfer Amount',
  '渠道订单ID': 'Channel Order ID',
  '原始金额': 'Original Amount',
  '手续费金额': 'Fee Amount',
  '订单使用渠道': 'Order Channel',
  '渠道开户账户ID': 'Channel Account ID',
  '支付币种': 'Payment Currency',
  '订单金额': 'Order Amount',
  '渠道扩展信息': 'Channel Extension Info',
  '目的': 'Purpose',
  '时间': 'Time',
  '账号': 'Account Number',
  '开户渠道': 'Account Channel',
  '开户币种': 'Account Currency',
  '最后更新时间': 'Last Updated',
  '账户名': 'Account Name',
  '银行所在国家': 'Bank Country',
  '开户子状态': 'Account Sub Status',
  '渠道用户ID': 'Channel User ID',
  '支付目的地ID': 'Payment Destination ID',
  '银行获取的用户全名': 'Full Name Retrieved from Bank',
  '同名校验结果': 'Name Match Result',
  '多个IBAN': 'Multiple IBANs',
  '退款原因': 'Refund Reason',
  '原订单金额': 'Original Amount',
  '退款到账金额': 'Refund Arrival Amount',
  '手续费币种': 'Fee Currency',
  '渠道订单号': 'Channel Order ID',
  '渠道类型': 'Channel Type',
  '需要开户': 'Need Account',
  '支持充值': 'Support Deposit',
  '支持提现': 'Support Withdraw',
  '支持退款': 'Support Refund',
  '总数': 'Total',
  '交易金额': 'Transaction Amount',
  '交易时间': 'Transaction Time',
  '是否退款': 'Is Refunded',
  '银行名称': 'Bank Name',
  '国家码': 'Country Code',
  '转账限额': 'Transfer Limits',
  '文件ID': 'File ID',
  '渠道ClientID': 'Channel Client ID',
  '失败原因': 'Failure Reason',
  '可用余额': 'Available Balance',
  '汇率': 'Exchange Rate',
  '状态码': 'Status Code',
  '业务状态码': 'Business Code',
  '响应消息': 'Message',
  '请求时间': 'Request Time',
  '业务数据': 'Business Data',
  '结果': 'Result',
};

// Tip translations
export const fieldTipMap = {
  '各渠道差异字段，JSON格式字符串，见下方': 'Channel-specific fields, JSON string format, see below',
  '幂等key': 'Idempotent key',
  '精确到小数点后两位': 'Precise to 2 decimal places',
  '正数，最大16位整数+2位小数': 'Positive, max 16 integer digits + 2 decimal places',
  '正数，AmountValid校验': 'Positive, AmountValid validation',
  '钱包支付成功后跳转页面': 'Redirect page after wallet payment success',
  '与orderId至少传一个': 'At least one of orderId required',
  '与externalOrderId至少传一个': 'At least one of externalOrderId required',
  '毫秒时间戳，最大支持一周': 'Epoch ms, max 1 week range',
  '毫秒时间戳': 'Epoch milliseconds',
  '最大100': 'Max 100',
  '2位或3位国家码': '2 or 3 letter country code',
  '单次最多50个': 'Max 50 per request',
  '200 表示成功': '200 means success',
  '000000 表示成功': '000000 means success',
  '如 success': 'e.g. success',
  '原样返回请求中的 requestId': 'Echoed from request requestId',
  '具体结构见各接口响应参数': 'See individual API response params',
  'true 表示关户成功': 'true means close successful',

  // === ACCOUNT_CREATE BASE_PARAMS ===
  'EQUALS_MONEY仅USD; LEAN_TECH仅AED; 其他渠道需checkSupportCurrency': 'EQUALS_MONEY: USD only; LEAN_TECH: AED only; others: checkSupportCurrency',
  'LEAN_TECH仅LEAN; BANKING_CIRCLE仅VIRTUAL_ACCOUNT; 其他: VIRTUAL_ACCOUNT / PIX / VIETQR / ZEN_WALLET / INTERACE_REQUEST / LEAN': 'LEAN_TECH: LEAN only; BANKING_CIRCLE: VIRTUAL_ACCOUNT only; others: VIRTUAL_ACCOUNT / PIX / VIETQR / ZEN_WALLET / INTERACE_REQUEST / LEAN',
  'LEAN_TECH仅INDIVIDUAL; 其他: INDIVIDUAL / BUSINESS / ADMINISTRATOR / ALL': 'LEAN_TECH: INDIVIDUAL only; others: INDIVIDUAL / BUSINESS / ADMINISTRATOR / ALL',
  '所有渠道均需传入，JSON格式字符串，见下方渠道差异字段': 'Required for all channels, JSON string format, see channel diff fields below',

  // === CARD_BIND BASE_PARAMS ===
  'BANK_FRICK/PYVIO外所有渠道必填': 'Required for all channels except BANK_FRICK/PYVIO',
  'EQUALS_MONEY/SGB/LEAN_TECH/KORAPAY必填; BANK_FRICK仅SWIFT必填; PYVIO仅USD必填': 'EQUALS_MONEY / SGB / LEAN_TECH / KORAPAY: required; BANK_FRICK: SWIFT only; PYVIO: USD only',
  'EQUALS_MONEY/SGB/LEAN_TECH/KORAPAY/PYVIO必填; BANK_FRICK/BANKING_CIRCLE仅bindType=BANKACCOUNT必填': 'EQUALS_MONEY / SGB / LEAN_TECH / KORAPAY / PYVIO: required; BANK_FRICK / BANKING_CIRCLE: bindType=BANKACCOUNT only',
  'BANKING_CIRCLE仅bindType=BANKACCOUNT必填，其余渠道均必填': 'BANKING_CIRCLE: bindType=BANKACCOUNT only; All other channels: required',
  '@Size(min=15,max=34); LEAN_TECH必填; BANK_FRICK/BANKING_CIRCLE仅bindType=IBAN必填': '@Size(min=15, max=34); LEAN_TECH: required; BANK_FRICK / BANKING_CIRCLE: bindType=IBAN only',
  'EQUALS_MONEY/SGB必填(2位); LEAN_TECH必填(3位); PYVIO/BANKING_CIRCLE必填(2位)': 'EQUALS_MONEY / SGB: required (2-letter); LEAN_TECH: required (3-letter); PYVIO / BANKING_CIRCLE: required (2-letter)',
  'BANK_FRICK/BANKING_CIRCLE必填: IBAN / BANKACCOUNT': 'Required for BANK_FRICK/BANKING_CIRCLE: IBAN / BANKACCOUNT',
  'EQUALS_MONEY/LEAN_TECH/BANK_FRICK/BANKING_CIRCLE/PYVIO必填，JSON格式字符串，见下方': 'Required for EQUALS_MONEY/LEAN_TECH/BANK_FRICK/BANKING_CIRCLE/PYVIO, JSON string format, see below',

  // === DEPOSIT_CREATE BASE_PARAMS ===
  'CurrencyEnum校验: USD / RUB / UAH / GBP / EUR / DKK / BRL / MXN / ARS / COP / AED / NGN / HKD / SGD / ALL': 'CurrencyEnum validation: USD / RUB / UAH / GBP / EUR / DKK / BRL / MXN / ARS / COP / AED / NGN / HKD / SGD / ALL',
  '正数，最大20位整数+2位小数': 'Positive, max 20 integer digits + 2 decimal places',
  'StrictCallbackUrl校验，allowHttp=true，不可为空': 'StrictCallbackUrl validation, allowHttp=true, cannot be empty',

  // === WITHDRAW_CREATE BASE_PARAMS ===
  'EQUALS_MONEY仅USD; LEAN_TECH仅AED; SGB需checkSupportCurrency; 其他渠道无特殊限制': 'EQUALS_MONEY: USD only; LEAN_TECH: AED only; SGB: checkSupportCurrency; others: no restriction',
  'EQUALS_MONEY仅USD; LEAN_TECH仅AED; INSWITCH仅BRL; SGB需checkSupportCurrency; TAZAPAY为holdingCurrency(扣款币种); 其他渠道无特殊限制': 'EQUALS_MONEY: USD only; LEAN_TECH: AED only; INSWITCH: BRL only; SGB: checkSupportCurrency; TAZAPAY: holdingCurrency (debit currency); others: no restriction',
  '正数，AmountValid校验; KORAPAY最低1000': 'Positive, AmountValid validation; KORAPAY minimum 1000',
  'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; 当前所有渠道实现均仅支持BANK_TRANSFER': 'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; currently all channels only support BANK_TRANSFER',
  'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; INSWITCH仅支持PIX_CODE; TAZAPAY仅支持BANK_TRANSFER': 'BANK_TRANSFER / PIX_CODE / INTERAC / EFT; INSWITCH: PIX_CODE only; TAZAPAY: BANK_TRANSFER only',
  'EQUALS_MONEY / SGB / PYVIO / LEAN_TECH / KORAPAY / BANK_FRICK / BANKING_CIRCLE / INSWITCH / TAZAPAY': 'EQUALS_MONEY / SGB / PYVIO / LEAN_TECH / KORAPAY / BANK_FRICK / BANKING_CIRCLE / INSWITCH / TAZAPAY',
  '必须以http://或https://开头': 'Must start with http:// or https://',
  '所有渠道均需传入，JSON格式字符串，见下方': 'Required for all channels, JSON string format, see below',

  // === ACCOUNT_CLOSE BASE_PARAMS ===
  'DTO无@NotBlank，但业务逻辑需要': 'No @NotBlank in DTO, but required by business logic',

  // === ORDER_PAGE BASE_PARAMS ===
  '最小值1': 'Minimum 1',
  'Service层checkParams校验': 'Service layer checkParams validation',

  // === FILE_UPLOAD BASE_PARAMS ===
  'ID_CARD / PASSPORT / DRIVER_LICENSE / SELFIE / ADDRESS_PROOF 等': 'ID_CARD / PASSPORT / DRIVER_LICENSE / SELFIE / ADDRESS_PROOF etc.',
  'jpg/png/pdf，最大10MB': 'jpg/png/pdf, max 10MB',

  // === Existing BASE_PARAMS tips ===
  '2位国家码, EQUALS_MONEY/SGB/KORAPAY/PYVIO/BANKING_CIRCLE必填': '2-letter country code, required for EQUALS_MONEY/SGB/KORAPAY/PYVIO/BANKING_CIRCLE',
  'LEAN_TECH非必填, SGB/EQUALS_MONEY/KORAPAY必填': 'Optional for LEAN_TECH, required for SGB/EQUALS_MONEY/KORAPAY',
  'LEAN_TECH必填(15-34位)': 'Required for LEAN_TECH (15-34 chars)',
  'BANK_FRICK/BANKING_CIRCLE时生效: IBAN / BANKACCOUNT': 'Effective for BANK_FRICK/BANKING_CIRCLE: IBAN / BANKACCOUNT',
  '如 ["SUCCESS","FAILED"]': 'e.g. ["SUCCESS","FAILED"]',
  '目前仅支持 PYVIO': 'Currently supports PYVIO only',
  'PYVIO/TAZAPAY渠道必填，JSON格式字符串，见下方渠道差异字段': 'Required for PYVIO/TAZAPAY, JSON string format, see channel diff fields below',
  'PYVIO / TAZAPAY': 'PYVIO / TAZAPAY',
  'INDIVIDUAL / BUSINESS; TAZAPAY仅支持BUSINESS': 'INDIVIDUAL / BUSINESS; TAZAPAY only supports BUSINESS',
  '渠道有多个账号时可指定': 'Specify when channel has multiple accounts',
  '固定值 PYVIO': 'Fixed value: PYVIO',
  'PYVIO必填: BENEFICIARY / SUPPLIER': 'Required for PYVIO: BENEFICIARY / SUPPLIER',
  'payeeType=BENEFICIARY时必填': 'Required when payeeType=BENEFICIARY',
  // RESPONSE_PARAMS tips
  '开户需要跳转外部链接时返回': 'Returned when account opening requires external redirect',
  '开户失败时返回': 'Returned on account opening failure',
  '开户成功时返回': 'Returned on successful account opening',
  '失败时返回': 'Returned on failure',
  'IBAN时必须': 'Required for IBAN',
  'IBAN时必须; ISO 3166-1 alpha-3': 'Required for IBAN; ISO 3166-1 alpha-3',
  'PROCESSING，最终状态通过webhook回调': 'PROCESSING, final status via webhook callback',
  'OFFLINE_DEPOSIT / PRE_ORDER': 'OFFLINE_DEPOSIT / PRE_ORDER',
  '渠道返回的额外信息，JSON格式': 'Extra info from channel, JSON format',
  '非换汇场景与 amount 一致，换汇场景为 payout 币种金额': 'Same as amount in non-FX scenario, payout currency amount in FX scenario',
  '非换汇场景与 currency 一致，换汇场景为 payout 币种': 'Same as currency in non-FX scenario, payout currency in FX scenario',
  '原始 payout 金额': 'Original Payout Amount',
  '原始 payout 币种': 'Original Payout Currency',
  'ISO 三字母国家代码': 'ISO 3-letter country code',
  '根据渠道返回不同字段': 'Fields vary by channel',
  'IBAN 或 accountNumber': 'IBAN or accountNumber',
  'Bank Identifier Code (BIC)': 'Bank Identifier Code (BIC)',
  '含 accountName / accountNumber / bic / bankName / bankCountry / bankAddress': 'Contains accountName / accountNumber / bic / bankName / bankCountry / bankAddress',
  '含 payType / payUrl / qrCode 等（非VA模式）': 'Contains payType / payUrl / qrCode etc. (non-VA mode)',
  '含 payType / payUrl / qrCode（非VA模式）': 'Contains payType / payUrl / qrCode (non-VA mode)',
  '非VA模式充值时返回': 'Returned for non-VA deposit mode',
  'VA模式充值时返回（BANK_FRICK）': 'Returned for VA deposit mode (BANK_FRICK)',
  'payType=AUTHORIZATION_ID 时有值': 'Available when payType=AUTHORIZATION_ID',
  'payType=AUTHORIZATION_ID 时有值; REVERSE_ENGINEERING / OPEN_BANKING': 'Available when payType=AUTHORIZATION_ID; REVERSE_ENGINEERING / OPEN_BANKING',
  'VA模式，BANK_FRICK使用': 'VA mode, used by BANK_FRICK',
  'SUCCESS: 解绑成功': 'SUCCESS: unbind successful',
  '后续提现使用': 'Used for subsequent withdrawal',
  '时间戳': 'Timestamp',
  '格式: 0.0000000000': 'Format: 0.0000000000',
  '多个externalUserId可对应同一个clientId': 'Multiple externalUserIds can map to one clientId',
  'ISO 三字母': 'ISO 3-letter',
  '含 currency / min / max': 'Contains currency / min / max',
  // extParam tips from DB metadata
  'userType为BUSINESS时，公司名称拆解填充此字段': 'For BUSINESS userType, split company name into this field',
  '+区号开头': 'Start with country code (+)',
  'yyyy-MM-dd 或 yyyy/MM/dd': 'yyyy-MM-dd or yyyy/MM/dd',
  '格式: DDMMYYYY, INDIVIDUAL=生日, BUSINESS=注册日期': 'Format: DDMMYYYY, INDIVIDUAL=DOB, BUSINESS=registration date',
  'P=护照, N=身份证, BUSINESS时传null': 'P=Passport, N=ID Card, null for BUSINESS',
  'INDIVIDUAL=身份证/护照号, BUSINESS=公司注册号, 1-100字符': 'INDIVIDUAL=ID/Passport No., BUSINESS=Registration No., 1-100 chars',
  'ISO-3 国家代码, INDIVIDUAL=居住国, BUSINESS=注册国': 'ISO-3 country code, INDIVIDUAL=residence, BUSINESS=registration',
  'ISO-3 国家代码, ^[A-Z]{3}$': 'ISO-3 country code, ^[A-Z]{3}$',
  '虚拟账号所有者全名, <=140字符, ^[a-zA-Z0-9 /\\-?:().,+]*$': 'VA owner full name, <=140 chars, ^[a-zA-Z0-9 /\\-?:().,+]*$',
  '银行的唯一标识符（从卡列表获取）': 'Unique bank identifier (from bank list API)',
  '由绑卡接口返回的recipientId': 'recipientId returned from card bind API',
  '3位字符, 如 SAL(工资)': '3-char code, e.g. SAL (salary)',
  '可以与开户传一个': 'Can use the same as account creation',
  '长度不超过32位': 'Max 32 characters',
  '长度100以内': 'Max 100 characters',
  'currency和targetCurrency不一致时必传': 'Required when currency differs from targetCurrency',
  'TARGET2ORIGIN: 到账金额为targetAmount; ORIGIN2TARGET: 支付金额为amount': 'TARGET2ORIGIN: arrival amount=targetAmount; ORIGIN2TARGET: payment amount=amount',
  '仅RTGS支持, Y=收款人姓名显示为自己': 'RTGS only, Y=show own name as recipient',
  'BEN=收款方承担, OUR=付款方承担, SHA=共同承担': 'BEN=beneficiary bears, OUR=sender bears, SHA=shared',
  '非IBAN模式(BANKACCOUNT)时必填, 格式: BIC/SWIFT、SC+sortCode(UK)、FW+fedwire(US)等': 'Required for non-IBAN mode, format: BIC/SWIFT, SC+sortCode(UK), FW+fedwire(US) etc.',
  '默认LOCAL': 'Default: LOCAL',
  '外部转账必填': 'Required for external transfer',
  'SWIFT方式必须提供': 'Required for SWIFT method',
  '自定义户名': 'Custom account name',
  'VA账户显示名称，将显示在ATM/银行应用': 'VA display name, shown on ATM/banking app',
  '支付成功后跳转页面': 'Redirect page after payment success',
  '2位国家代码': '2-letter country code',
  '3位国家代码, BRL对应BRA': '3-letter country code, BRL maps to BRA',
  'BENEFICIARY=本人账户, SUPPLIER=第三方账户': 'BENEFICIARY=own account, SUPPLIER=third-party account',
  'userType=BUSINESS时必填, FI=金融机构, NON_FI=非金融机构': 'Required for BUSINESS, FI=financial institution, NON_FI=non-financial',
  'KYC传个人姓名, KYB传企业名称': 'KYC: personal name, KYB: company name',
  'KYC传本人BVN, KYB传对应董事BVN, 必须11位': 'KYC: personal BVN, KYB: director BVN, must be 11 digits',
  'personal=BVN号, personal_nin=NIN号, company=CAC号(RC或BN开头)': 'personal=BVN, personal_nin=NIN, company=CAC (RC or BN prefix)',
  'personal=BVN校验, personal_nin=NIN校验, company=CAC校验': 'personal=BVN validation, personal_nin=NIN validation, company=CAC validation',
  'personal_nin类型时使用, 必须11位': 'For personal_nin type, must be 11 digits',
  '个人=姓名, 企业=CAC上的公司名': 'Individual=name, Business=company name on CAC',
  'email和mobile必须至少一个有值': 'At least one of email or mobile required',
  '和email不能同时为空; 钱包方式(LINKAJA/OVO/GOPAY/DANA/SHOPEEPAY)必填, 格式: 62xxxxxxxxx 或 08xxxxxxxxxx': 'Cannot be empty with email; required for wallet methods, format: 62xxx or 08xxx',
  '和mobile不能同时为空': 'Cannot be empty with mobile',
  'CPF(11位) 或 CNPJ(14位)': 'CPF (11 digits) or CNPJ (14 digits)',
  'BRL: CPF(11位)/CNPJ(14位), ARS: DNI(8位)/CUIT(11位)': 'BRL: CPF(11)/CNPJ(14), ARS: DNI(8)/CUIT(11)',
  '对应accountType的PIX key': 'PIX key matching accountType',
  '默认clabe': 'Default: clabe',
  'protocol=clabe时传18位CLABE号, debitcard传借记卡号, phonenum传手机号': 'clabe=18-digit CLABE, debitcard=card number, phonenum=phone',
  'protocol为debitcard或phonenum时必填': 'Required for debitcard or phonenum protocol',
  'PSE方式必填': 'Required for PSE method',
  'PSE/KHIPU方式必填': 'Required for PSE/KHIPU method',
  'PSE方式必填(57开头), OXXOPay方式必填, ARS币种必填': 'Required for PSE (57 prefix), OXXOPay, or ARS currency',
  'KHIPU方式必填': 'Required for KHIPU method',
  'KHIPU方式可不提供': 'Optional for KHIPU method',
  'ARS币种必填': 'Required for ARS currency',
  'payeeType=BENEFICIARY时必须, fileId': 'Required when payeeType=BENEFICIARY, fileId',
  '根据币种和国家不同选择不同枚举值': 'Enum values vary by currency and country',
  'FIS=金融服务, TCS=电信, MWP=钱包支付, OAT=本人转账, IFS=信息服务, RNT=租金, LNC=贷款, PIN=个人投资, GDS=商品买卖': 'FIS=Financial, TCS=Telecom, MWP=Wallet, OAT=Own Transfer, IFS=Info, RNT=Rent, LNC=Loan, PIN=Investment, GDS=Goods',
};
